(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["products-mega-menu"] && !Shopify.designMode) return;
  try {
    class ProductsMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('[data-pm-trigger]');
      this.panel = this.querySelector('[data-pm-panel]');
      this.back = this.querySelector('[data-pm-back]');
      this.backLabel = this.querySelector('[data-pm-back-label]');
      this.l1Links = Array.from(this.querySelectorAll('[data-pm-l1-link]'));
      this.l2Links = Array.from(this.querySelectorAll('[data-pm-l2-link]'));
      this.l2Panes = Array.from(this.querySelectorAll('[data-pm-l2-pane]'));
      this.l3Panes = Array.from(this.querySelectorAll('[data-pm-l3-pane]'));
      this.l1Items = Array.from(this.querySelectorAll('.pm__l1-item'));

      // Opening index comes from Liquid so the panel opens on the category the
      // buyer is already browsing instead of always on the first one.
      this.activeL1 = parseInt(this.dataset.pmOpenL1, 10) || 0;
      this.activeL2 = parseInt(this.dataset.pmOpenL2, 10) || 0;
      this.open = false;
      this.hoverTimer = null;
      this.scrollLock = null;

      // Bound once so they can actually be removed again on disconnect.
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onViewportChange = this.onViewportChange.bind(this);
      this.mq = window.matchMedia('(max-width: 989px)');
    }

    get isMobile() {
      return this.mq.matches;
    }

    connectedCallback() {
      // The bar the panel hangs from: the whole sticky header (contact strip +
      // header row). Its bottom edge is where the panel's top edge belongs.
      this.bar = this.closest('.header-wrapper') || this.closest('header');
      this.section = this.closest('.section-header');

      this.trigger.addEventListener('click', this.toggle.bind(this));
      this.back.addEventListener('click', this.onBack.bind(this));

      this.l1Links.forEach((link) => {
        link.addEventListener('mouseenter', this.onL1Hover.bind(this));
        link.addEventListener('focus', this.onL1Focus.bind(this));
        link.addEventListener('click', this.onL1Click.bind(this));
      });

      this.l2Links.forEach((link) => {
        link.addEventListener('mouseenter', this.onL2Hover.bind(this));
        link.addEventListener('focus', this.onL2Focus.bind(this));
        link.addEventListener('click', this.onL2Click.bind(this));
      });

      // One cancel point for both columns: leaving the panel abandons any
      // pending switch rather than letting it fire after the pointer has gone.
      this.panel.addEventListener('mouseleave', () => clearTimeout(this.hoverTimer));

      document.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      clearTimeout(this.hoverTimer);
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('click', this.onDocClick);
      this.stopTracking();
      this.unlockScroll();
    }

    toggle(event) {
      event.preventDefault();
      if (this.open) this.close();
      else this.openPanel();
    }

    openPanel() {
      this.open = true;
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.setActive(this.activeL1, this.activeL2);
      this.setMobileLevel(null);
      this.lockScroll();
      this.pinToHeader();
      this.startTracking();
    }

    close() {
      this.open = false;
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.setMobileLevel(null);
      clearTimeout(this.hoverTimer);
      this.stopTracking();
      this.unlockScroll();
    }

    /* ---- scroll lock + header pinning ----
       The bug: the page kept scrolling underneath the open panel. The header
       scrolled away (and the sticky header hid itself once past its own
       height) while the panel stayed put, so the two came apart and page
       content slid past behind the menu. Two fixes:
         1. While the panel is open the page does not scroll. Wheel and touch
            input over a column scroll that column (overscroll-behavior already
            stops it chaining out); anywhere else, nothing moves.
         2. The panel's top edge is measured from the header's real bottom edge
            when it opens, instead of trusting --header-height, which is only
            right when the page is scrolled to the very top. */
    lockScroll() {
      if (this.scrollLock) return;
      const root = document.documentElement;
      this.scrollLock = {
        overflow: root.style.overflow,
        gutter: root.style.scrollbarGutter,
      };
      // Keep the scrollbar's space reserved so the page does not jump sideways
      // when the bar disappears -- but only if there was a scrollbar to begin
      // with, otherwise a short page would gain a gutter and shift left.
      if (window.innerWidth > root.clientWidth) root.style.scrollbarGutter = 'stable';
      root.style.overflow = 'hidden';
    }

    unlockScroll() {
      if (!this.scrollLock) return;
      const root = document.documentElement;
      root.style.overflow = this.scrollLock.overflow;
      root.style.scrollbarGutter = this.scrollLock.gutter;
      this.scrollLock = null;
    }

    pinToHeader() {
      if (!this.bar) return;
      // Measure from wherever the panel is really positioned from. That is
      // normally the viewport, but a transform or filter on any ancestor turns
      // position:fixed into a local frame, and a hard-coded number lands wrong.
      this.panel.style.top = '0px';
      const frameTop = this.panel.getBoundingClientRect().top;
      const barBottom = this.bar.getBoundingClientRect().bottom;
      this.panel.style.top = Math.max(0, Math.round(barBottom - frameTop)) + 'px';
    }

    startTracking() {
      window.addEventListener('resize', this.onViewportChange);
      // The sticky header slides in with a short transition; if the panel was
      // opened mid-slide, re-measure once the header has settled.
      if (this.section) this.section.addEventListener('transitionend', this.onViewportChange);
    }

    stopTracking() {
      window.removeEventListener('resize', this.onViewportChange);
      if (this.section) this.section.removeEventListener('transitionend', this.onViewportChange);
    }

    onViewportChange(event) {
      if (!this.open) return;
      // transitionend bubbles up from every hover fade inside the header; only
      // the header's own slide matters here.
      if (event && event.type === 'transitionend' && event.target !== this.section) return;
      this.pinToHeader();
    }

    /* ---- hover intent ----
       Both columns wait the same beat before switching. Travelling diagonally
       from a category to its subcategories drags the pointer across the rows
       in between; without the delay the panel flipped under the cursor. */
    scheduleActive(l1, l2) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout(() => this.setActive(l1, l2), 120);
    }

    onL1Hover(event) {
      if (this.isMobile) return;
      this.scheduleActive(parseInt(event.currentTarget.dataset.pmL1Link, 10), 0);
    }

    onL1Focus(event) {
      clearTimeout(this.hoverTimer);
      this.setActive(parseInt(event.currentTarget.dataset.pmL1Link, 10), 0);
    }

    onL2Hover(event) {
      if (this.isMobile) return;
      const [l1, l2] = event.currentTarget.dataset.pmL2Link.split('-').map(Number);
      this.scheduleActive(l1, l2);
    }

    onL2Focus(event) {
      clearTimeout(this.hoverTimer);
      const [l1, l2] = event.currentTarget.dataset.pmL2Link.split('-').map(Number);
      this.setActive(l1, l2);
    }

    onL1Click(event) {
      const el = event.currentTarget;
      const idx = parseInt(el.dataset.pmL1Link, 10);
      clearTimeout(this.hoverTimer);

      if (this.isMobile) {
        event.preventDefault();
        this.setActive(idx, 0);
        this.setMobileLevel('l2');
        return;
      }
      // Categories with no destination render as <button>, so there is no
      // navigation to cancel here -- they just switch the panel.
      this.setActive(idx, 0);
    }

    onL2Click(event) {
      const el = event.currentTarget;
      const [l1, l2] = el.dataset.pmL2Link.split('-').map(Number);
      clearTimeout(this.hoverTimer);

      if (this.isMobile) {
        // Only drill in when there is genuinely a level below. Previously any
        // L2 opened a pane, and one without subcategories cost the buyer a tap
        // to reach a single link back out to the same collection.
        if (el.dataset.pmHasSubs === 'true') {
          event.preventDefault();
          this.setActive(l1, l2);
          this.setMobileLevel('l3');
        }
        return;
      }
      this.setActive(l1, l2);
    }

    setMobileLevel(level) {
      this.classList.toggle('is-mobile-l2', level === 'l2');
      this.classList.toggle('is-mobile-l3', level === 'l3');
      this.back.hidden = level === null;

      if (level === 'l2') {
        this.backLabel.textContent = 'All categories';
      } else if (level === 'l3') {
        const item = this.l1Items[this.activeL1];
        const name = item ? item.querySelector('.pm__l1-label') : null;
        this.backLabel.textContent = name ? name.textContent.trim() : 'Back';
      }
    }

    onBack() {
      if (this.classList.contains('is-mobile-l3')) this.setMobileLevel('l2');
      else this.setMobileLevel(null);
    }

    setActive(l1, l2) {
      this.activeL1 = l1;
      this.activeL2 = l2;

      this.l1Items.forEach((item) => {
        item.classList.toggle('is-active', parseInt(item.dataset.pmL1, 10) === l1);
      });
      this.l2Panes.forEach((pane) => {
        pane.classList.toggle('is-active', parseInt(pane.dataset.pmL2Pane, 10) === l1);
      });
      this.l3Panes.forEach((pane) => {
        pane.classList.toggle('is-active', pane.dataset.pmL3Pane === l1 + '-' + l2);
      });

      const activePane = this.querySelector('[data-pm-l2-pane="' + l1 + '"]');
      if (activePane) {
        activePane.querySelectorAll('.pm__l2-item').forEach((item) => {
          item.classList.toggle('is-active', parseInt(item.dataset.pmL2, 10) === l2);
        });
        activePane.scrollTop = 0;
      }
    }

    onKeyDown(event) {
      if (!this.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        this.trigger.focus();
      }
    }

    onDocClick(event) {
      if (!this.open) return;
      if (this.contains(event.target)) return;
      this.close();
    }
  }

  if (!customElements.get('products-mega-menu')) {
    customElements.define('products-mega-menu', ProductsMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
